import { getPKFromID } from 'utilities';
import UserContentItemWithLocation from '../UserContentItemWithLocation';
import UserContentFlashcardDeck from '../UserContentFlashcardDeck/UserContentFlashcardDeck';

class UserContentFlashcard extends UserContentItemWithLocation {
  static typeName = 'flashcards';

  static uuidIdRelations = [{ type: UserContentFlashcardDeck, key: 'deckKey' }];

  deckKey;
  snippet;
  userText;
  confidenceLevel;
  lastModified;
  lastViewed;
  isImportant;
  isSwapped;

  constructor(properties = {}) {
    super(...arguments);

    this.deckKey = properties.deckKey;

    this.snippet = properties.snippet ?? '';
    this.userText = properties.userText ?? '';
    this.confidenceLevel = properties.confidenceLevel;
    this.lastModified = properties.lastModified;
    this.lastViewed = properties.lastViewed;
    this.isSwapped = properties.isSwapped;
    this.isImportant = properties.isImportant;
  }

  inFlashcardDeck(deck) {
    return deck.id === this.deckKey || deck.uuid === this.deckKey;
  }

  serialize() {
    const {
      deckKey,
      snippet,
      userText,
      confidenceLevel,
      lastModified,
      lastViewed,
      isImportant,
      isSwapped,
    } = this;

    return {
      ...super.serialize(),

      deckKey,
      snippet,
      userText,
      confidenceLevel,
      lastModified,
      lastViewed,
      isImportant,
      isSwapped,
    };
  }

  async persist({ createMutation, updateMutation, deleteMutation }) {
    const { confidenceLevel, deckKey, isSwapped, snippet, userText } = this;
    const flashcardDeckId = getPKFromID(deckKey);

    if (this.isPersistedOnce) {
      if (this.shouldDelete) {
        await deleteMutation({ variables: { id: this.pk } });

        return null;
      }

      const response = await updateMutation({
        variables: {
          id: this.pk,
          input: {
            description: userText,
            flashcardDeckId,
            isSwapped,
            confidenceLevel,
            term: snippet,
          },
        },
      });

      return response.data.updateFlashcard.flashcard.id;
    }

    const { spineEntryIndex, epubPageIndex } =
      this.locationPropertiesForGraphQL;

    const {
      data: { createFlashcard },
    } = await createMutation({
      variables: {
        input: {
          description: userText,
          flashcardDeckId,
          term: snippet,
          isSwapped,
          confidenceLevel,
          spineEntryIndex,
          epubPageIndex,
        },
      },
    });

    return createFlashcard.flashcard.id;
  }
}

export default UserContentFlashcard;
